export default __webpack_public_path__ + "static/media/carregando.e65da2ac.png";